import { getLayoutData, getPageData, getPages } from "../api/api"
import ExtendedContent from "@/components/common/ExtendedContent"
import { useEffect, useState } from "react"
import { setCssVars } from "@repo/utils"
import { FRAGMENTS } from "@repo/ui/lib"
import { DESIGN_FRAGMENTS } from "@/lib"
import dynamic from "next/dynamic"
import TagsBanner from "@repo/ui/src/components/Banners/TagsBanner"

const StickyHeading = dynamic(() => import("@repo/ui/src/components/StickyHeading"), {
	ssr: false,
})

export default function Page({ data, locale }) {
	const competences = data?.chooseCompetences || []
	const content = data?.content || []
	const stickyHeadingsSelectors = data?.stickyHeadingsSelector || []

	const bannerData = {
		header: data?.banner?.header?.text || "",
		backButton: data?.backButtonText || "",
		backToAllButton: data?.backToAllButtonText || "",
		backLink: "/services",
		card: data?.card || {},
		areaColor: data?.areaColorBackground?.cssRgb,
		borderColor: data?.borderColor?.cssRgb,
	}
	const tags = {
		header: locale === "pl" ? "Kompetencje:" : "Competences:",
		data: competences,
		prefix: "competence/",
	}
	const [savedTimeState, setSavedTime] = useState(null)
	useEffect(() => {
		const savedTime = localStorage.getItem("videoTime")
		if (savedTime) {
			setSavedTime(savedTime)
		} else {
			setSavedTime(1)
		}
	}, [])
	useEffect(() => {
		setCssVars(document.body, {
			"service-color": bannerData.areaColor,
		})
	}, [])
	return (
		<>
			{savedTimeState && <StickyHeading stickyHeadingsSelectors={stickyHeadingsSelectors} />}
			<TagsBanner data={bannerData} videoData={data} tags={tags} isNewServices />
			{savedTimeState && <ExtendedContent content={content} isServicePage={true} />}
		</>
	)
}

const PAGE_CONTENT_TYPE = `allCommonServicePages`
const PLEO_TYPE = "design"

const pathsQuery = `
query GetSingleService($locale: SiteLocale) {
	${PAGE_CONTENT_TYPE}(filter: {pleoType: {eq: "${PLEO_TYPE}"}} , locale: $locale, first: 100) {
        title
        serviceName
        slug
        pleoType
	}
}
`

const propsQuery = `
	query GetService($slug: String, $locale: SiteLocale) {
        allCommonServicePages(locale: $locale, filter: { slug: { eq: $slug }, pleoType: {eq: "${PLEO_TYPE}"}}) {
            title
            serviceName
            ${FRAGMENTS.SEO_META_FRAGMENT}
            slug
            pleoType
            banner{
              header{
                text
              } 
            }
            backButtonText
            backToAllButtonText
            card {
                icon {
                    ${FRAGMENTS.IMAGE_FRAGMENT}
                }
            }
            areaColorBackground{
              cssRgb
            }
            borderColor{
              cssRgb
            }
            videoFile {
                ${FRAGMENTS.VIDEO_FRAGMENT}
            }
            chooseCompetences {
                id
                name: competenceName
                slug
                disableCompetence
            }
            ${DESIGN_FRAGMENTS.STICKY_HEADING_FRAGMENT}
            content{
                __typename
                ${FRAGMENTS.CHECK_OTHER_SERVICES_FRAGMENT} 
				${FRAGMENTS.TEXT_MODULE_FRAGMENT}
				${FRAGMENTS.TECHNOLOGIES_TILES_FRAGMENT}
                ${FRAGMENTS.BENEFITS_MODULE_FRAGMENT}
                ${FRAGMENTS.CLIENTS_ABOUT_US_RECORD_FRAGMENT}
                ${FRAGMENTS.NUMBERS_RECORD_FRAGMENT}
                
                ${DESIGN_FRAGMENTS.TILES_MODULE_FRAGMENT}
                ${DESIGN_FRAGMENTS.SINGLE_ASSET_FRAGMENT}
                ${DESIGN_FRAGMENTS.FAQ_FRAGMENT}
                ${DESIGN_FRAGMENTS.CHECK_OTHERS_FRAGMENT}
                ${DESIGN_FRAGMENTS.PROJECTS_GRID_FRAGMENT}
            }
        }
	}
`

export async function getStaticProps({ params, locale }) {
	const { slug } = params
	const data = await getPageData("allCommonServicePages", slug, propsQuery, locale)
	const { globals, cookies, footer, menu } = await getLayoutData(locale)
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			footer,
			menu,
		},
		revalidate: 120,
	}
}

export async function getStaticPaths({ locales }) {
	const paths = []
	for (const locale of locales) {
		const projectPosts = await getPages("allCommonServicePages", pathsQuery, locale)
		const posts = projectPosts.map((page) => ({
			params: {
				slug: page.slug,
			},
			locale,
		}))
		paths.push(...posts)
	}
	// { fallback: false } means other routes should 404.
	return {
		paths,
		fallback: false,
	}
}
